// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box } from '@material-ui/core';
import CompanyForm from '../../../common/CompanyForm';

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    minHeight: '500px',
    paddingTop: theme.spacing(1),
  },
}));

function CompanyDetailsPage(props) {
  const [t] = useTranslation();
  const classes = useStyles();

  const { company, onUpdateCompany, onGoBack, actionsDisabled } = props;

  return (
    <Box id="CompanyDetailsTab-container" className={classes.container}>
      <CompanyForm
        company={company}
        onSave={onUpdateCompany}
        onCancel={onGoBack}
        cancelButtonText={t('common.back')}
        cancelButtonIcon="chevron_left"
        actionsDisabled={actionsDisabled}
        editMode
      />
    </Box>
  );
}

CompanyDetailsPage.propTypes = {
  company: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    cvrNumber: PropTypes.number,
    eanNumber: PropTypes.string,
    status: PropTypes.string,
    segment: PropTypes.string,
    department: PropTypes.string,
    address: PropTypes.string,
    zipcode: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    phone: PropTypes.string,
    invoiceEmail: PropTypes.string,
    contactName: PropTypes.string,
    contactPhone: PropTypes.string,
    contactEmail: PropTypes.string,
    notes: PropTypes.string,
  }).isRequired,
  onUpdateCompany: PropTypes.func.isRequired,
  onGoBack: PropTypes.func.isRequired,
  actionsDisabled: PropTypes.bool.isRequired,
};

export default CompanyDetailsPage;
